// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1IZDJ","buttons":"RemoveExpirationActionButtons_buttons__25dki"};